<div id="splash-screen">
  <img class="logo" [src]="appS.environment.logo_url + 'img/logo/manager_loading.png'" alt="Logo" />
  <img class="loading" [src]="appS.environment.logo_url + 'img/loading/loading.gif'" />
</div>
